export enum VehiclePaintType {
	Metallic = 'metallic',
	Classic = 'classic',
	Pearl = 'pearl', // По внешнему виду не отличается от Classic
	Matte = 'matte',
	Metals = 'metals',
	Chrome = 'chrome',
	Chameleon = 'chameleon',
}

export const VEHICLE_PAINT_TYPE_INDEX: Record<VehiclePaintType, number> = {
	[VehiclePaintType.Metallic]: 0,
	[VehiclePaintType.Classic]: 1,
	[VehiclePaintType.Pearl]: 2,
	[VehiclePaintType.Matte]: 3,
	[VehiclePaintType.Metals]: 4,
	[VehiclePaintType.Chrome]: 5,
	[VehiclePaintType.Chameleon]: 6,
};

export interface IVehicleBodyColor {
	color: number | string; // HEX-строка у RGB-цветов и index-номер у не RGB цветов
	type: VehiclePaintType;
	pearlColor?: number;
}

export interface IVehiclePaint {
	bodyColor: IVehicleBodyColor;
	interiorColor: string;
	brakesColor?: number;
	rimsColor?: number;
	windowTint?: number;
}

export function isRgbPaintType(type: VehiclePaintType): boolean {
	if (type === VehiclePaintType.Chrome || type === VehiclePaintType.Chameleon) {
		return false;
	}

	return true;
}
